import * as React from 'react';
import * as ReactDom from 'react-dom';
export var renderCompAndReturnUnmount = function (elem, component, props) {
    ReactDom.render(React.createElement(component, props), elem);
    return function () {
        ReactDom.unmountComponentAtNode(elem);
    };
};
//# sourceMappingURL=render-comp-and-return-unmount.js.map